import { FC } from 'react';
// eslint-disable-next-line no-restricted-imports
import ReactLoadingSkeleton, { SkeletonProps } from 'react-loading-skeleton';

import clsx from 'clsx';

import './Skeleton.scss';

// TODO: Move to componentLibrary (Design System) with proper story and documentation

const Skeleton: FC<SkeletonProps> = ({ className, ...otherProps }) => {
    return <ReactLoadingSkeleton className={clsx(className, 'skeleton')} {...otherProps} />;
};

export default Skeleton;
